"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableEventEmitter = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
/*
 * Emits an addEventListener/removeEventListener event to a separate EventEmitter
 * whenever a listener is added or removed
 */
class ObservableEventEmitter {
    delegate = new eventemitter3_1.default();
    observer = new eventemitter3_1.default();
    on(eventName, listener) {
        this.delegate.on(eventName, listener);
        this.observer.emit('addEventListener', eventName);
    }
    once(eventName, listener) {
        const wrappedFn = (payload) => {
            listener(payload);
            this.observer.emit('removeEventListener', eventName);
        };
        this.delegate.once(eventName, wrappedFn);
        this.observer.emit('addEventListener', eventName);
    }
    off(eventName, listener) {
        this.delegate.off(eventName, listener);
        this.observer.emit('removeEventListener', eventName);
    }
    removeAllListeners() {
        const eventNames = this.delegate.eventNames();
        this.delegate.removeAllListeners();
        for (const eventName of eventNames) {
            this.observer.emit('removeEventListener', eventName);
        }
    }
    emit(eventName, payload) {
        this.delegate.emit(eventName, payload);
    }
    getListenerCount(eventName) {
        return this.delegate.listenerCount(eventName);
    }
    getObserver() {
        return this.observer;
    }
}
exports.ObservableEventEmitter = ObservableEventEmitter;
//# sourceMappingURL=ObservableEventEmitter.js.map